import { createContext, useContext, useEffect, useState } from 'react';
import { useMoralis } from 'react-moralis';
import { GetFlowDetails } from '../queries/Superfluid';

const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    balance: {},
    activeFlows: {},
  });
  const { isWeb3Enabled, user, Moralis } = useMoralis();

  useEffect(() => {
    (async () => {
      try {
        if (user) {
          const tokens = {};
          const activeFlows = {};

          const balance = await Moralis.Web3API.account.getTokenBalances({
            chain: 'mumbai',
          });
          balance.forEach((e) => {
            tokens[e.token_address] = { ...e };
          });

          const active = await GetFlowDetails({
            owner: user.get('ethAddress'),
            recipient: '0x11cE7098577Ac50510fe8712b622Ea0f7A9FA6d3',
          });
          active.forEach((e) => {
            activeFlows[e.token.symbol] = { ...e };
          });

          setUserData((state) => ({ ...state, tokens, activeFlows }));
        }
      } catch (err) {
        console.log(err);
      }
    })();
  }, [user, isWeb3Enabled]);

  return (
    <UserContext.Provider value={userData}>{children}</UserContext.Provider>
  );
};

const useUser = () => useContext(UserContext);

export default useUser;
